export const uk = {
    all: 'Все',
    'region-except': '{region} (кроме {except})'
};
